@if (open$ | async) {
  <div class="sn-palette-backdrop" aria-hidden="true" (click)="close()"></div>
  <div class="sn-palette" role="dialog" aria-modal="true" aria-label="Search the menu"
       cdkTrapFocus [cdkTrapFocusAutoCapture]="true" (keydown.escape)="close()">
    <app-nav-menu-search variant="palette" (picked)="picked()" (dismissed)="close()"></app-nav-menu-search>
  </div>
}
